import styled, { css } from 'styled-components'
import { backgroundColor } from 'uiComponents/constants/colors'
import { fontFamilyPrimary } from 'uiComponents/constants/typography'

export const StyledProductImage = styled.div<{
  hoverEffect?: boolean
  padded?: boolean
  reducedPaddingTop?: boolean
}>`
  position: relative;
  width: 100%;
  border-radius: 4px;
  ${fontFamilyPrimary};
  background-color: ${backgroundColor};
  height: 0;
  padding-top: ${({ reducedPaddingTop }) =>
    reducedPaddingTop ? '128%' : '133%'};
  overflow: hidden;

  ${({ hoverEffect }) =>
    hoverEffect &&
    css`
      &:hover {
        opacity: 0.8;
      }
    `};

  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `};
  & > img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-height: 100%;
    max-width: 100%;
    height: auto;
    margin: auto;
    @supports (object-fit: cover) {
      object-fit: cover;
      object-position: center;
      height: 100%;
      width: 100%;
    }
    ${({ padded }) =>
      padded &&
      css`
        inset: 0%;
        padding: 10% 10% 18%;
        max-height: 100%;
        max-width: 100%;
        @supports (object-fit: cover) {
          object-fit: contain;
        }
      `};
  }
`
